import { Origin, Patient, Prescriber, RQE } from './users';
import { Establishment } from './establishment';
import { ManualMedicine, Medicine } from './medicine';
import { Exam } from './exam';
import { CERTIFICATES } from '../containers/certificate/certificates';
import { MedicalCertificate } from './medicalCertificate';
import { MedicalReferral } from './MedicalReferral';
import { MedicalReport } from './medicalReport';
import { SEARCH_TYPE } from '../components/search/SearchTypeEnum';
import { CID10Estruturado } from './structuredIcd';
import { Formula } from './formula';

export interface Prescription {
  Itens: Medicine[];
  ItensManuais: ManualMedicine[];
  NecessitaNotificacaoReceitaPapel: boolean;
  CIDS10Estruturados: CID10Estruturado[];
  Diagnosticos: string[];
  Formulas: Formula[];
  DataCriacao: Date;
  ReferenciaInterna: string;
  Prescritor: Prescriber;
  Paciente: Patient;
  Origem: Origin;
  Estabelecimento: Establishment;
  idPrescricaoStatus: PRESCRIPTION_STATUS;
  idPrescricao: number;
  TemBeneficio: boolean;
  Tags: any[];
  RequerReceituarioEspecial: boolean;
  PrescricaoAssinada: boolean;
  CodigoValidacao: string;
  URLBarCode: string;
  URLQRCode: string;
  CertificadoDigitalObrigatorio: boolean;
  PlanosDesconto: any[];
  ExibirCertificadoLocal: boolean;
  ExibirEmailParaEnvio: boolean;
  PermitirImpressao: boolean;
  CorPrimaria?: string;
  CorSecundaria?: string;
  LogoURL?: string;
  Exames: Exam[];
  UltimoMetodoAssinatura?: CERTIFICATES;
  PDFUrl?: string;
  Atestado: MedicalCertificate | null;
  Atestados: MedicalCertificate[];
  ExamePDFUrl?: string;
  AtestadoPDFUrl?: string;
  ExibirPorPrincipioAtivo: boolean;
  RQESelecionado: RQE | null;
  Comentario?: string;
  Documentos: PrescriptionDocument[];
  Encaminhamentos: MedicalReferral[];
  PodeFiltrarRename: boolean;
  PodeFiltrarRemume: boolean;
  Relatorios: MedicalReport[];
  AbaAtiva?: ACTIVE_TAB;
  UrlPacientes: string;
  idPrescritor: number;
  PrescricaoPorAudio?: {
    Habilitado: canUsePrescriptionByAudio;
    HabilitadoMobile?: canUsePrescriptionByAudio;
  };
}

export type canUsePrescriptionByAudio = boolean;

export interface PosologiaEstruturada {
  TotalTratamento: string;
  Quantidade: string;
  Unidade: string;
  UnidadePlural: string;
  EmbalagemSugerida: number;
  QuantidadeEmbalagemSugerida: number;
}

export interface PosologiaResponseType {
  IdMedicamento: number;
  nomeMedicamento: string;
  controlado: number;
  tipoAntimicrobiano: string;
  embalagensDisponiveis: string;
  quantidade: string;
  unidade: string;
  unidade_plural?: string;
  frequencia: string;
  vezes_por_dia: number;
  duracao: string;
  pausa: string;
  dias: number;
  condicao: string | null;
  uso_continuo: boolean;
  raw_response: string;
  total_tratamento: string;
  hash_posologia: string;
  embalagem_sugerida: number;
  quantidade_embalagem_sugerida: number;
  regras_usadas: string;
  embalagem_exata: string;
}

export interface PosologyHistoricItem {
  posology: string;
  totalTratamento: string | null;
  quantidade: string | null;
  quantidadeEmbalagemSugerida: number | null;
  unidade: string | null;
  unidadePlural: string | null;
  embalagemSugerida: number | null;
}

export interface PrescriptionByAudioResponseType {
  examsAdded: number;
  medicationsAdded: number;
  processingTimeMs: number;
}

export enum PRESCRIPTION_STATUS {
  INITIADED = 1,
  EMITTED = 2,
  DISMISSED = 3,
  PARTIAL_DISMISSED = 4,
  CANCELED = 5,
  REPLACED = 6,
  PENDING_SIGNATURE = 7,
  SAVED = 8,
  BLOCKED = 9,
  CANCELED_POST_EMISSION = 10,
}

export interface PrescriptionDocument {
  Assinado: boolean;
  Categoria: string;
  ContentType: string;
  TipoDocumento: string;
  URL: string;
}

export enum ACTIVE_TAB {
  PRESCRIPTION = 'Receita',
  EXAM = 'Exame',
  CERTIFICATE = 'Atestado',
  REPORT = 'Relatório',
  REFERRAL = 'Encaminhamento',
}

export const ACTIVE_TAB_MAP_TO_SEARCH_TAB = {
  [ACTIVE_TAB.PRESCRIPTION]: SEARCH_TYPE.MEDICINE,
  [ACTIVE_TAB.EXAM]: SEARCH_TYPE.EXAMS,
  [ACTIVE_TAB.CERTIFICATE]: SEARCH_TYPE.MEDICAL_CERTIFICATE,
  [ACTIVE_TAB.REFERRAL]: SEARCH_TYPE.MEDICAL_REFERRAL,
  [ACTIVE_TAB.REPORT]: SEARCH_TYPE.MEDICAL_REPORT,
};
